import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CalenderRoutingModule } from './calender-routing.module';
import { CalenderComponent } from './calender/calender.component';
import { FormsModule } from '@angular/forms';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { DatePipe, JsonPipe, NgClass, NgTemplateOutlet } from '@angular/common';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { ViewComponent } from './view/view.component';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';


@NgModule({
  declarations: [
    CalenderComponent,
    ViewComponent
  ],
  imports: [
    CommonModule,
    CalenderRoutingModule,
    FormsModule,
    NzDatePickerModule,
    DatePipe, 
    JsonPipe, 
    NgClass, 
    NgTemplateOutlet,
    NzButtonModule,
    NzTabsModule,
    NzSpinModule,
    NzSelectModule,
    NzModalModule,
    NzTagModule,
    NzTableModule,
    NzDrawerModule 
  ],
  exports: [
    ViewComponent
  ]
})
export class CalenderModule { }
